import React from "react";
import informationIcon from "../../assets/img/Information.svg";

const TextInputTyped = ({
  answer,
  handleChange,
  error,
  question,
  name,
  info,
}) => {
  // Prevent numbers from being entered
  const onInputChange = (e) => {
    const value = e.target.value;
    // Only allow non-numeric input
    if (/^\d+$/.test(value)) {
      // If the value is only digits, do not update
      return;
    }
    // Only allow input with no numbers anywhere
    if (/\d/.test(value)) {
      // If the value contains any digit, do not update
      return;
    }
    handleChange(e);
  };

  return (
    <div className="cus_form basic_question_box">
      <div className="custom_filed custom_basic">
        <div className="form-group">
          <label htmlFor={name} className="basic">
            {question}
            {info && (
              <img
                src={informationIcon}
                alt="Information"
                data-toggle="tooltip"
                data-placement="bottom"
                title={typeof info === "string" ? info : ""}
                style={{ cursor: "pointer", marginLeft: "5px" }}
              />
            )}
          </label>
          <input
            type="text"
            className="form-control"
            autoComplete="off"
            id={name}
            name={name}
            placeholder="Enter value"
            value={answer}
            onChange={onInputChange}
          />
          {error && (
            <p className="text-danger" style={{ marginTop: "5px" }}>
              {error}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default TextInputTyped;
